import axios from 'axios';
import { toMetricsUI } from '../../mappers/direct/toMetricsUI';
import { toPromotionDto } from '../../mappers/direct/toPromotionDto';
import {
    DirectCampaignModel,
    DirectCompaniesResponseDto,
    DirectCounterDto,
    DirectMetricsUI,
    DirectPromotionUI,
} from './types';

export async function loadDirectMetrics(): Promise<DirectMetricsUI> {
    const response = await axios.get('/direct/metrika_counters/v2');

    const metrics: DirectCounterDto[] = response.data?.counters || [];

    return toMetricsUI(metrics);
}

export async function loadDirectCampaigns(businessId: string): Promise<DirectCampaignModel[]> {
    const response = await axios.get(`/direct/campaigns/v2/${businessId}`);

    const companiesResponse: DirectCompaniesResponseDto = response.data;

    return companiesResponse.direct_data.map((item) => ({
        ...item.campaign_data,
        startDate: item.campaign_data.start_date,
        weeklyLimit: item.campaign_data.weekly_limit,
        feedSettings: item.feed_settings,
        utmParams: item.campaign_data.tracking_params,
        strategyType: item.campaign_data.strategy_type,
        payFor: item.campaign_data.pay_for,
        budgetType: item.campaign_data.budget_type,
        spendLimitType: item.campaign_data.spend_limit_type,
        spendLimitAmount: item.campaign_data.average_cpc || item.campaign_data.crr,
    }));
}

export async function saveDirectPromotion(data: DirectPromotionUI) {
    const response = await axios.post('/direct/campaigns/v2', toPromotionDto(data));

    return response.data?.campaign_id;
}

export async function updateDirectCampaignState(
    companyId: number,
    businessId: string,
    action: string,
): Promise<void> {
    await axios.patch(`/direct/campaigns/${companyId}/state`, {
        action,
        business_id: businessId,
    });
}

export async function editDirectPromotion(companyId: string, data: DirectPromotionUI) {
    return await axios.patch(`/direct/campaigns/v2/${companyId}`, toPromotionDto(data));
}

export async function loadDirectLogins(): Promise<string[]> {
    const result = await axios.get('/direct/available_logins');

    return result.data.logins;
}
